import React from "react";
import PropTypes from "prop-types";
import { Divider, Grid, Paper, Typography } from "@mui/material";
import { displayDate } from "../../../utils/dataUtils";
import { displayMemberType } from "../../../utils/memberUtils";
import BeltAvatar from "../../../components/beltavatar/BeltAvatar";
import { gradArray } from "../../../components/form/fields/inputFields";

function MemberDetails({ member }) {
  return (
    <Paper elevation={3} style={{ padding: 20, margin: 20 }}>
      <Typography variant="h4" gutterBottom>
        {`${member.title} ${member.firstName} ${member.lastName}`}
      </Typography>
      <Typography>
        <strong>Grad: {gradArray[member.degree].label}</strong>
      </Typography>
      <Typography>
        <div style={{ maxWidth: 150 }}>
          <BeltAvatar
            beltNumber={member["degree"]}
            size="medium"
            justify={"flex-start"}
          />
        </div>
      </Typography>
      <Divider style={{ margin: "10px 0" }} />

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="h4">Mitgliedsdaten</Typography>
          <Typography>
            <strong>Standort: </strong>
            {member.standortRef.siteName}
          </Typography>
          <Typography>
            <strong>Mitglieds-Nr.: </strong>
            {member.memberNumber}
          </Typography>
          <Typography>
            <strong>Geburtstag:</strong> {displayDate(member.birthdate)}
          </Typography>
          <Typography>
            <strong>Alter:</strong> {member.age}
          </Typography>
          <Typography>
            <strong>Körpergröße:</strong>{" "}
            {Number.isFinite(Number(member?.bodyHeightCm))
              ? `ca. ${Math.round(Number(member.bodyHeightCm))} cm`
              : "Nicht hinterlegt"}
          </Typography>

          <Typography>
            <strong>Letzte Prüfung:</strong> {displayDate(member.lastTesting)}
          </Typography>
          <Typography>
            <strong>Vertragsdatum:</strong> {displayDate(member.contractDate)}
          </Typography>
          <Typography>
            <strong>Aktiv seit:</strong> {displayDate(member.beginningDate)}
          </Typography>
          <Typography>
            <strong>Art:</strong> {displayMemberType(member.memberType)}
          </Typography>
          <Typography>
            <strong>Erstelldatum:</strong> {displayDate(member.createdAt)}
          </Typography>
          <Typography>
            <strong>Status:</strong> {member.status}
          </Typography>
          <Typography>
            <strong>Beitrag:</strong> {member.contribution} €
          </Typography>
          {/* Add more member details as needed */}
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h4">Vertragsdaten</Typography>
          <Typography>
            <strong>Kontoinhaber:</strong> {member.contractRef.owner}
          </Typography>
          <Typography>
            <strong>Bank:</strong> {member.contractRef.bank}
          </Typography>
          <Typography>
            <strong>BIC:</strong> {member.contractRef.bic}
          </Typography>
          <Typography>
            <strong>IBAN:</strong> {member.contractRef.iban}
          </Typography>
          <Typography>
            <strong>Vertragsnehmer:</strong>{" "}
            {member.contractRef.title +
              " " +
              member.contractRef.firstName +
              " " +
              member.contractRef.lastName}
          </Typography>
          <Typography>
            <strong>Geburtstag:</strong>{" "}
            {displayDate(member.contractRef.birthdate)}
          </Typography>
          <Typography>
            <strong>Straße, Nr:</strong> {member.contractRef.street}
          </Typography>
          <Typography>
            <strong>Stadt:</strong> {member.contractRef.city}
          </Typography>
          <Typography>
            <strong>PLZ:</strong> {member.contractRef.zip}
          </Typography>
          <Typography>
            <strong>Stadt:</strong> {member.contractRef.city}
          </Typography>
          <Typography>
            <strong>Telefon:</strong> {member.contractRef.phoneNumber}
          </Typography>
          <Typography>
            <strong>Mobil:</strong> {member.contractRef.mobile}
          </Typography>
          <Typography>
            <strong>Mail:</strong> {member.contractRef.email}
          </Typography>
          {/* Add more details as needed */}
        </Grid>
      </Grid>
    </Paper>
  );
}

MemberDetails.propTypes = { member: PropTypes.object };

export default MemberDetails;
